module.exports = __webpack_public_path__ + "img/contact.3ada2dfd.jpeg";